export default __webpack_public_path__ + "static/media/Datorsal6.4909ba41.jpeg";